import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {cleanName} from '../../utils/string/string.util';
import {Card} from '../../utils/models/cards/card';
import {CardsService} from 'src/app/services/cards/cards.service';
import {CacheService} from 'src/app/services/cache/cache.service';

@Component({
    selector: 'app-genesys-deckchecker',
    templateUrl: './genesys-deckchecker.component.html',
    styleUrls: ['./genesys-deckchecker.component.scss']
  })
  export class GenesysComponent implements OnInit {
    cards: Card[] = [];
    cleanName = cleanName;
    decklist = '';
    resultSections: any[] = [];
    grandTotal = 0;
  
    constructor(private cardService: CardsService)
     {}
  
    async ngOnInit() {
      this.cards = await this.cardService.getAllCards();
    }
  
    parseDecklist() {
      let text = this.decklist;
      const sections = {};
      let currentSection = null;
      if(text.startsWith("ydke://")) {
        return this.parseYDKEintoSections(text);
      } else {

        text.split("\n").forEach(line => {
          line = line.trim();
          if (!line) return;
          
          if (line.endsWith(":")) {
            currentSection = line.replace(":", "");
            sections[currentSection] = [];
          } else if (currentSection) {
            const match = line.match(/^(\d+)\s+(.+)$/);
            if (match) {
              const qty = parseInt(match[1], 10);
              const name = match[2].trim();
              sections[currentSection].push({ name, qty });
            }
          }
        });
        
        return sections;
      }
    }

    parseYDKEintoSections(ydke:string){
      const components = ydke.slice("ydke://".length).split("!");
      if (components.length < 3) throw new Error("Missing ydke URL component");
      const mainIds =  this.base64ToPasscodes(components[0]);
      const extraIds = this.base64ToPasscodes(components[1]);
      const sideIds  = this.base64ToPasscodes(components[2]);
      // Counts each id's occurence and creates an object per id with qty
      const mainDeck = Array.from(
        mainIds.reduce((map, id) => map.set(id, (map.get(id) || 0) + 1), new Map()),
        ([id, qty]) => ({ id, qty })
      );
      const extraDeck = Array.from(
        extraIds.reduce((map, id) => map.set(id, (map.get(id) || 0) + 1), new Map()),
        ([id, qty]) => ({ id, qty })
      );
      const sideDeck = Array.from(
        sideIds.reduce((map, id) => map.set(id, (map.get(id) || 0) + 1), new Map()),
        ([id, qty]) => ({ id, qty })
      );
      const sections = {"Main Deck":mainDeck, "Extra Deck": extraDeck, "Side Deck":sideDeck};
      return sections;
    }

    base64ToPasscodes(base64:string) {
      const binaryStr = atob(base64);
      const length = binaryStr.length;
      const bytes = new Uint8Array(length);
      for (var i = 0; i < length; i++) bytes[i] = binaryStr.charCodeAt(i);
      return new Uint32Array(bytes.buffer);
    }
  
    displayDeckValues() {
      const deckSections = this.parseDecklist();
      this.resultSections = [];
      this.grandTotal = 0;
  
      for (const section in deckSections) {
        let sectionTotal = 0;
        const cards = [];
  
        deckSections[section].forEach(cardInput => {
          let cardFound;
          if(cardInput.name) {
            cardFound = this.cards.find(c => c.name == cardInput.name);
          } else if (cardInput.id) {
            cardFound = this.cards.find(c => c.id == cardInput.id);
          }
  
          if (!cardFound) {
            cards.push({
              text: `${cardInput.qty}x ${cardInput.name || cardInput.id} → Card not found ⚠️`,
              cssClass: "expensive"
            });
          } else {
            const value = Number(cardFound.misc_info[0].genesys_points);
  
            let valueClass = "";
            if (value > 0 && value < 33) valueClass = "cheap";
            if (value >= 33 && value < 100) valueClass = "costy";
            if (value >= 100) valueClass = "expensive";
  
            const subtotal = value * cardInput.qty;
            sectionTotal += subtotal;

            let subtotalClass = "";
            if (subtotal > 0 && subtotal < 33) subtotalClass = "cheap";
            if (subtotal >= 33 && subtotal < 100) subtotalClass = "costy";
            if (subtotal >= 100) subtotalClass = "expensive";
  
            cards.push({
              qty: cardInput.qty,
              name: cardFound.name,
              value,
              subtotal,
              valueClass: valueClass,
              subtotalClass: subtotalClass
            });
          }
        });
  
        this.resultSections.push({
          name: section,
          total: sectionTotal,
          cards
        });
  
        this.grandTotal += sectionTotal;
      }
    }

    resetFields() {
      this.decklist = '';
      this.resultSections = [];
      this.grandTotal = 0;
    }
  }
  